export const ht = {
    "TRIGGER_LISTEN" : "Koute pou deklanche",
    "ASSIST_EMPTY_MSG" : "Ajan AI ap koute konvèsasyon ou ak pare pou ede otomatikman lè deklanche.",
    "MYBOT_TRIGGET_LISTEN" : "Pa gen travay aktif My Bot kounye a",
    "MYBOT_EMTPY_MSG" : "Pou kòmanse yon travay sou My Bot, ale nan onglè rechèch epi chwazi opsyon \"Kouri ak opinyon ajan\" pou travay ou vle a.",
    "PROACTIVE_MODE": "Mòd Proaktif",
    "SETTINGS": "Anviwònman",
    "AUTO_SCROLL_TOOLTIP":"Kontwole woule otomatik nan Asistan Tab, Bot mwen & Kontni Tab Transkripsyon",
    "HELP_AND_SUPPORT": "Èd & Sipò",
    "HELP": "Èd",
    "LANGUAGE": "Lang",
    "THEME": "Tèm",
    "AUTOMATIC": "Otomatik",
    "FILE_NAME":"Non dosye",
    "DARK": "Nwa",
    "LIGHT": "Limyè",
    "THEME_DESC": "Sa a pral itilize mòd default sistèm ou a",
    "DOCUMENTATION": "Dokimantasyon",
    "DOC_DESC": "Tcheke atik detaye dokimantasyon nou yo.",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "Tcheke kesyon ki poze souvan sou Ajan AI.",
    "KORE_ACADEMY": "Akademi Kore",
    "KORE_ACA_DESC": "Aprann plis sou Ajan AI atravè kou akademi an.",
    "SEARCH": "Rechèch",
    "MY_BOT": "My Bot",
    "TAB_TEXT":"Pa gen okenn ongl pèmèt! Tanpri aktive omwen yon ongl",
    "ASSIST": "Ede",
    "TRANSCRIPT": "Transkripsyon",
    "HISTORY" : "Istwa",
    "STARTOVER" : "Rekòmanse",
    "RESTART_INPUTS" : "Rekòmanse ak opinyon kaptire yo",
    "ASKCUSTOMER" : "Mande Kliyan",
    "TELLCUSTOMER" : "Di Kliyan",
    "WELCOME_MSG" : "Mesaj Byenveni",
    "TAP_SEARCH":"Tape pou rechèch",
    "SEND" : "Voye",
    "SENT" : "Voye",
    "AWAITING" : "Ap tann repons  |  Tape pou kontinye",
    "OVERRIDE" : "Tape pou kontinye",
    "OVERRIDE_FILE" : "Tache Fichye pou kontinye",
    "ACCEPT_RESPONSE" : "Repons Aksepte",
    "AGENT_ENTERED" : "Ajan Antre",
    "EXPECTED_FORMAT" : "Fòma Atann", 
    "INPUT_VALUES" : "Valè Opinyon", 
    "RESTART" : "Rekòmanse",
    "START_OVER" : "Rekòmanse",
    "RESTART_CAPTURE" : "Rekòmanse ak opinyon kaptire yo",
    "CANCEL" : "Anile",
    "INTERRUPT_DIALOG" : "Dyalòg Entèwonpri",
    "RUN" : "Kouri",
    "RUN_AGENT" : "Kouri ak opinyon Ajan",
    "STEP" : "Etap",
    "DIALOG_TASK" : "Travay Dyalo",
    "FAQ" : "FAQ",
    "SNIPPET" : "Repons",
    "ARTICLE" : "Paj wèb",
    "FILE" : "Fichye",
    "SUGGESTED" : "Sijere",
    "ALL_DIALOG" : "Tout Travay Dyalo",
    "DIALOG_TEXT" : "Dyalo",
    "INTENT_IDENTIFIED" : "Konprann Diskou Kliyan an",
    "NOT_WHAT_LOOKING" : "Sijesyon Mal ?",
    "BOT" : "Bot", 
    "CUSTOMER" : "Kliyan",
    "YOU" : "Ou",
    "TERMINATE_CONV" : "Fèmen Travay Dyalo",
    "TERMINATE_CONV_DESC" : "Èske ou sèten ou vle fèmen travay dyalo a? Ajan AI pap kapab fè plis sijesyon.",
    "YES_TERMINATE" : "Wi, Fèmen",
    "NO_CANCEL" : "Non, Anile",
    "OVERRIDE_CONTINUE" : "Kontinye ak mòd entèwonpri",
    "SUMMARY_TEXT" : "Rezime",
    "SUBMIT" : "Soumèt",
    "INTERRUPT_OCCURED" : "Entèwonpri Te Pase",
    "IDENTIFIED_INTENT" : "Entansyon Idantifye",
    "INTERRUPT_DESC" : "Kouri sa ap sispann travay dyalo ou ap fè kounye a.",
    "ACCEPT_RUN" : "Aksepte epi Kouri",
    "RUN_LATER" : "Kouri Pita",
    "KNOW_MORE" : "Konnen Plis",
    "MORE_TEXT" : "Plis",
    "LESS_TEXT" : "Mwens",
    "VIEW_MORE" : "Gade Plis",
    "VIEW_LESS" : "Gade Mwens",
    "SHOW_MORE_FAQ" : "Montre plis FAQ",
    "SHOW_LESS_FAQ" : "Montre mwens FAQ",
    "SHOW_MORE_ARTICLE" : "Montre plis paj wèb",
    "SHOW_LESS_ARTICLE" : "Montre mwens paj wèb",
    "SHOW_MORE_SNIPPET" : "Montre plis repons",
    "SHOW_LESS_SNIPPET" : "Montre mwens repons",
    "SHOW_MORE_FILES" : "Montre plis fichye",
    "SHOW_LESS_FILES" : "Montre mwens fichye",
    "VIEW_ALL_DIALOG" : "Gade tout Dyalo",
    "VIEW_FEW_DIALOG" : "Gade kèk Dyalo",
    "HELP_FULL" : "Èske sa te itil?",
    "THANKYOU" : "Mèsi!",
    "EXPAND_MORE" : "Elaji / Plis",
    "CLOSE_TEXT" : "Fèmen",
    "STARTED" : "Kòmanse",
    "ENDED" : "fini",
    "VIEW_FULL_ARTICLE" : "Gade paj wèb la",
    "VIEW_FULL_FILE" : "Gade fichye a",
    "COPIED" : "Kopi",
    "SENTI_ANALY" : "Analiz Santiman",
    "WRONG_SUGGESTION" : "Move sijesyon",
    "INCORRECT_INTENT" : "Entansyon Kòrèk",
    "ACCIDENTAL_CLICK" : "Klik Aksidan",
    "TIME_TAKING" : "Pran tan",
    "OTHER" : "Lòt",
    "PLAYBOOK_EMPTY_MSG" : "Chwazi Playbook",
    "PLAYBOOK_EMPTY_DESC" : "Ajan AI pa ka chaje playbook la akoz tout playbook yo se dinamik. Klike sou 'Chwazi Playbook' pou jwenn aksè a playbook la",
    "STAGE" : "Etap", 
    "PROCEED_TO_CLOSE" : "Kontinye fèmen",
    "RECOMENDED_PLAYBOOK" : "REKÒMANDE PLAYBOOK",
    "PRIMARY_SCRIPTS" : "SCRIPTS PRIMÈ",
    "DYNAMIC_SCRIPTS" : "SCRIPTS DINAMIK",
    "RESUME" : "Rezime",
    "ENABLE_CLOSE" : "Klike sou bouton kontinye pou fèmen pou aktive Etap Fèmen",
    "LIST_VIEW" : "Lis View",
    "TERMINATE" : "Fèmen",
    "MINIMIZE" : "Minimize",
    "MAXIMIZE" : "Maksimize",
    "NO_SEARCH_RESULT" : "Pa jwenn okenn rezilta rechèch",
    "SENTIMENT_AWAITING" : "Ap tann pou santiman",
    "POSITIVE" : "Pozitif",
    "NEGATIVE" : "Negatif",
    "PLAYBOOK": "Liv jwèt",
    "ASSOCIATED_WORK_NOTES": "Nòt Rezolisyon Pase",
    "AGENT_JOINED_CONV": "Ajan rantre nan konvèsasyon an",
    "AUTOSCROLL_ASSIST" : "Auto-Scroll Kontni Ede",
    "FILE_SIZE_MSG" : "Gwosè fichye dwe nan 25MB. Tanpri eseye ankò.",
    "OVERRIDE_BTN" : "Deviye",
    "CHOOSE_FILE" : "Chwazi Fichye",
    "SUMMARY_ERROR_TEXT" : "Nou regrèt, men gen yon pwoblèm pou kreye rezime a pou konvèsasyon sa a. Tanpri kreye rezime pwòp ou.",
    "ASK_A_QUESTION": "Mande yon kesyon",
    "COPY" : "Kopi",
    "TELL_US_MORE": "Di nou plis...",
    "THANKS_FEEDBACK": "Mèsi pou fidbak ou",
    "SOMETHING_WRONG": "Gen yon bagay ki mal",
    "CLICK_ERROR_DETAILS": "Klike pou wè detay erè yo",
    "NO_ACTIVE_PLAYBOOK": "Pa gen okenn liv jwèt aktif",
    "REPHRASE_QUESTION": "Eske ou ka rephrase kesyon ou a oswa poze yon lòt bagay?",
    "INTERNAL_INFO": "Enfòmasyon entèn",
    "SOURCES": "Sous",
    "CONVERSATION_SUMMARY": "Rezime konvèsasyon an",
    "WAITING": "Ap tann",
    "WIDGET_DISABLED": "Widget a dezaktive",
    "AI_SETTINGS_DISABLED": "Paramèt AI yo dezaktive! Tanpri kontakte administratè AI a",
    "SERVER_CONNECTION_ERROR": "Erè pandan konekte ak sèvè a",
    "VIEW": "Gade",
    "ATTACHMENT_INPUT": "Antre atachman",
    "TYPE_SUMMARY": "Tape rezime a",
    "VIEW_FULL_ARTICLE_2": "Gade atik konplè a",
    "VIEW_FULL_FILE_2": "Gade fichye konplè a",
    "BY":"Pa",
    GENERATE_SUMMARY: "Jenere rezime",
    PREV_SUMMARIES: "Rezime yo te jenere anvan",
    DIALOG_WORKFLOWS: "Workflow Dyalog yo",
    SHOW_ALL_DIALOG: "Montre tout travay dyalog yo",
    SHOW_ALL_DIALOGS: "Montre tout dyalog yo",
    CUSTOM_TAB: "Tab Personnalise",
    AGENT_INPUT: "Antre Ajan",
    "CUSTOM_EMPTY_MSG" : "Pa gen okenn travay aktif kounye a",
    "CUSTOM_TAB_DESC" : "Pou kouri yon travay, kouri yon travay ki nan lis la ki nan kote a jwenn nan tab la.",
    "SUBMIT_OVERALL_FEEDBACK" : "Soumèt rezime jeneral",
    "FEEDBACK_POPUP_SUBTITLE" : "Rezime jeneral pou atik & fonksyon yo",
    "FEEDBACK_SATISFIED" : "Satisfè",
    "FEEDBACK_UNSATISFIED" : "Satisfè pa",
    "FEEDBACK_PROVIDE_REASONS" : "Fè plis enfòmasyon…",
    "FEEDBACK_TITLE" : "Rezime jeneral",
    "AGENTIC_THINKING" : "Ap panse",
    "AGENTIC_AGENT_TITLE" : "Ajan",
    "AGENTIC_COPILOT_MODE_TITLE" : "Mòd Copilot Ajan",
    "AGENTIC_SENDING_MESSAGE" : "Voye...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot ap koute aktivman konvèsasyon ou epi li pare pou ede otomatikman",
    "AGENTIC_SEARCH_RESULTS" : "Rezilta Ajan",
    "PAUSE_AUTO_SEND" : "Poz Voye Otomatik",
    "PAUSE_AGENTIC" : "Poz Ajan",
    "RESUME_AGENTIC" : "Rekòmanse Ajan",
    "RESUME_AUTO_SEND" : "Rekòmanse Voye Otomatik"
}